import { MouseEvent, MouseEventHandler, useCallback } from "react";
import { useSwipeable } from "react-swipeable";
import { ProductSearchHistoryItemPresentation } from "./ProductSearchHistoryItemPresentation";

interface ProductSearchHistoryItemProps {
  historyItem: string;
  showDelete: boolean;
  onShowDelete: () => void;
  onHideDelete: () => void;
  onDelete: () => void;
  onClick: () => void;
  onMouseDown?: MouseEventHandler<HTMLDivElement> | undefined;
}

export const ProductSearchHistoryItem = ({
  historyItem,
  showDelete,
  onShowDelete,
  onHideDelete,
  onDelete,
  onClick,
  onMouseDown,
}: ProductSearchHistoryItemProps) => {
  const handlers = useSwipeable({
    onSwipedLeft: () => {
      if (!showDelete) onShowDelete();
    },
    onSwipedRight: () => {
      if (showDelete) onHideDelete();
    },
    trackMouse: true,
  });

  const handleDeleteClick = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation();
      onDelete();
      onHideDelete();
    },
    [onDelete, onHideDelete]
  );

  return (
    <ProductSearchHistoryItemPresentation
      handlers={handlers}
      onDelete={handleDeleteClick}
      showDelete={showDelete}
      historyItem={historyItem}
      onClick={onClick}
      onMouseDown={onMouseDown}
    />
  );
};
